import { render, staticRenderFns } from "./collection-modal.vue?vue&type=template&id=9aa6aa42&"
import script from "./collection-modal.vue?vue&type=script&lang=js&"
export * from "./collection-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports